import { render, staticRenderFns } from "./cartFooter.vue?vue&type=template&id=9971033c&scoped=true&"
import script from "./cartFooter.vue?vue&type=script&lang=ts&"
export * from "./cartFooter.vue?vue&type=script&lang=ts&"
import style0 from "./cartFooter.vue?vue&type=style&index=0&id=9971033c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9971033c",
  null
  
)

export default component.exports